// needs to be in sync with containerGrid.css
export const gap = 16
export const cols = {
  default: 6,
  lg: 12,
}
